// Copyright ©️ 2026 eVolve MEP, LLC

import { WrappedSelect } from 'components/Mantine/TypeSafeSelect/WrappedSelect';

export type ActiveAllFilter = 'active' | 'all';

type ActiveAllSelectProps = {
  value: ActiveAllFilter | null;
  onChange: (value: ActiveAllFilter) => void;
  /**
   * The label of the data type that is being filtered. Will be prepended with "active" or "all" depending on the current value.
   */
  dataLabel: string;
  /**
   * Whether to show a Label on the select.
   * @defaultValue true
   */
  withLabel?: boolean;
};

/**
 * A Select that allows the user to select "Active" or "All" of a given data type
 */
export const ActiveAllSelect = ({ value, onChange, dataLabel, withLabel = true }: ActiveAllSelectProps) => {
  const activeLabel = `Active ${dataLabel}`;
  return (
    <WrappedSelect<ActiveAllFilter>
      value={value === 'active' ? null : value}
      onChange={(newValue) => onChange(newValue ?? 'active')}
      data={[
        {
          value: 'active',
          label: activeLabel,
        },
        {
          value: 'all',
          label: `All ${dataLabel}`,
        },
      ]}
      label={withLabel ? dataLabel : undefined}
      placeholder={activeLabel}
      withinPortal={false}
      clearable
    />
  );
};
